import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { ConfigurationDetailsComponent } from './configuration-details.component';
import { IconsModule } from 'src/app/icons/icons.module';
import { MatDividerModule } from '@angular/material/divider';
import { MatTabsModule } from '@angular/material/tabs';
import { PipesModule } from '../../../pipes/pipes.module';
import { ErrorDialogJarModule } from 'src/app/components/error-dialog-jar/error-dialog-jar.module';

@NgModule({
  declarations: [
    ConfigurationDetailsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    IconsModule,
    MatDividerModule,
    MatTabsModule,
    PipesModule,
    ErrorDialogJarModule
  ],
  exports: [
    ConfigurationDetailsComponent
  ]
})
export class ConfigurationDetailsModule { }
